'use strict';

const libPictView = require('pict-view');

const CO_CSS = /*css*/`
	.co-wrap { padding: 0.25rem 0.1rem 1.5rem; }
	.co-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 1rem; margin: 0 0 1rem; flex-wrap: wrap; }
	.co-eyebrow { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-text-muted, #8a94a3); }
	.co-title { font-size: 1.3rem; font-weight: 700; color: var(--theme-color-text-primary, #1f2733); margin: 0.15rem 0 0; display: flex; align-items: center; gap: 0.6rem; }
	.co-back { cursor: pointer; color: var(--theme-color-brand-primary, #5650e6); }
	.co-back:hover { text-decoration: underline; }
	.co-head-actions { display: flex; align-items: center; gap: 0.6rem; flex-wrap: wrap; }
	.co-btn { font-size: 0.85rem; font-weight: 600; padding: 0.5rem 0.85rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 7px; background: var(--theme-color-background-primary, #fff); color: var(--theme-color-text-primary, #1f2733); cursor: pointer; white-space: nowrap; }
	.co-btn:hover { background: var(--theme-color-background-secondary, #f5f6fb); }
	.co-btn-primary { background: var(--theme-color-brand-primary, #5650e6); border-color: var(--theme-color-brand-primary, #5650e6); color: #fff; }
	.co-btn-primary:hover { background: var(--theme-color-brand-primary-hover, #4740d4); }
	.co-form-host { margin-top: 0.8rem; border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; padding: 0.5rem; min-height: 12rem; background: var(--theme-color-background-primary, #fff); }
	.co-filter { width: 22rem; max-width: 100%; box-sizing: border-box; font-size: 0.9rem; padding: 0.5rem 0.7rem; border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 7px; background: var(--theme-color-background-primary, #fff); }
	.co-filter:focus { outline: none; border-color: var(--theme-color-brand-primary, #5650e6); box-shadow: 0 0 0 2px rgba(86,80,230,0.15); }
	.co-note { font-size: 0.9rem; color: var(--theme-color-text-secondary, #45505f); padding: 1.4rem 0.4rem; }
	.co-note-error { color: var(--theme-color-status-error, #cf5b5b); }
	.co-note-info { background: var(--theme-color-background-secondary, #f5f6fb); border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 7px; padding: 0.6rem 0.8rem; margin: 0 0 0.8rem; }
	.co-note-locked { text-align: center; }
	.co-mode { font-size: 0.86rem; border-radius: 7px; padding: 0.55rem 0.8rem; margin: 0 0 0.8rem; display: flex; align-items: center; gap: 0.5rem; }
	.co-mode-required { color: #8a5a00; background: rgba(184,134,11,0.12); border: 1px solid rgba(184,134,11,0.25); }
	.co-mode-direct { color: var(--theme-color-text-secondary, #45505f); background: var(--theme-color-background-secondary, #f5f6fb); border: 1px solid var(--theme-color-border-light, #e8ebf0); }
	.co-list { display: flex; flex-direction: column; }
	.co-row { display: grid; grid-template-columns: 8rem 1fr 8rem 7.5rem 7rem 1.4rem; align-items: center; gap: 0.6rem; padding: 0.6rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); }
	.co-row-head { font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #8a94a3); border-bottom: 1px solid var(--theme-color-border-default, #d7dce3); }
	.co-row-click { cursor: pointer; }
	.co-row-click:hover { background: var(--theme-color-background-secondary, #f5f6fb); }
	.co-c-num { font-weight: 650; color: var(--theme-color-text-primary, #1f2733); }
	.co-c-desc { color: var(--theme-color-text-secondary, #45505f); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.co-c-amt { text-align: right; font-variant-numeric: tabular-nums; color: var(--theme-color-text-primary, #1f2733); }
	.co-c-date { color: var(--theme-color-text-muted, #8a94a3); font-size: 0.85rem; }
	.co-c-chev { color: var(--theme-color-text-muted, #c8cfd8); text-align: right; }
	.co-pill { font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; padding: 0.1rem 0.5rem; border-radius: 9px; white-space: nowrap; }
	.co-st-draft { color: #5a6573; background: rgba(90,101,115,0.12); }
	.co-st-pending { color: #b8860b; background: rgba(184,134,11,0.14); }
	.co-st-submitted { color: #2f6fed; background: rgba(47,111,237,0.13); }
	.co-st-approved { color: #1c8a54; background: rgba(28,138,84,0.14); }
	.co-st-rejected { color: #cf5b5b; background: rgba(207,91,91,0.14); }
	.co-detail-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 0.9rem 1.4rem; padding: 1rem 0.2rem 0.4rem; border-top: 1px solid var(--theme-color-border-light, #eef1f5); }
	.co-field { display: flex; flex-direction: column; gap: 0.2rem; }
	.co-field-label { font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #8a94a3); }
	.co-field-value { font-size: 0.95rem; color: var(--theme-color-text-primary, #1f2733); font-variant-numeric: tabular-nums; }
	.co-form-link { color: var(--theme-color-brand-primary, #5650e6); text-decoration: none; font-size: 0.9rem; }
	.co-form-link:hover { text-decoration: underline; }
	.co-block { margin: 0.9rem 0.2rem 0; }
	.co-block-label { font-size: 0.66rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #8a94a3); margin-bottom: 0.25rem; }
	.co-block-body { font-size: 0.92rem; color: var(--theme-color-text-secondary, #45505f); white-space: pre-wrap; }
	.co-lines-label { margin: 1.4rem 0.2rem 0.4rem; display: flex; align-items: center; gap: 0.5rem; }
	.co-lines-count { font-size: 0.7rem; font-weight: 700; color: #fff; background: var(--theme-color-text-muted, #8a94a3); border-radius: 9px; padding: 0.02rem 0.45rem; }
	.co-lines { border: 1px solid var(--theme-color-border-light, #e8ebf0); border-radius: 8px; overflow: hidden; }
	.co-lrow { display: grid; grid-template-columns: 5rem 1fr 7rem 8rem 8rem 8rem; align-items: center; gap: 0.5rem; padding: 0.5rem 0.7rem; border-bottom: 1px solid var(--theme-color-border-light, #eef1f5); font-size: 0.88rem; }
	.co-lrow:last-child { border-bottom: none; }
	.co-lrow-head { font-size: 0.64rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--theme-color-text-muted, #8a94a3); background: var(--theme-color-background-tertiary, #f4f6f9); }
	.co-l-qty, .co-l-cpu, .co-l-amt { text-align: right; font-variant-numeric: tabular-nums; }
	.co-l-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
`;

/**
 * ChangeOrders — the ProjectWorkspace Contract ▸ Change Orders tab. A thin shell embedded into the workspace tab
 * host (openInto / exitEmbed / render-override, like ProjectFunding); all logic + HTML live in the provider,
 * painted into #CO-Body.
 */
class ChangeOrders extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
		// When embedded in the ProjectWorkspace tab host this holds that host selector; every render targets it.
		this._embedDestination = null;
	}

	get provider() { return this.pict.providers.ChangeOrders; }

	/** Render into the embed host when embedded (so provider-triggered repaints land in the tab, not the app container). */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		const tmpDestination = (typeof pRenderDestinationAddress === 'string') ? pRenderDestinationAddress : (this._embedDestination || undefined);
		return super.render(pRenderableHash, tmpDestination, pTemplateRecordAddress, pRootRenderable);
	}

	/** Embed the change-orders surface into a host for a fixed project; reloads only when the project differs. */
	openInto(pIDProject, pHostSelector)
	{
		this._embedDestination = pHostSelector;
		const tmpProvider = this.provider;
		if (tmpProvider && (!tmpProvider.hasModel || (Number(tmpProvider.idProject) !== Number(pIDProject))))
		{
			tmpProvider.loadAsync(pIDProject);
		}
		else { this.render(); }
	}

	exitEmbed() { this._embedDestination = null; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		if (this.provider) { this.provider.renderBody(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ChangeOrders;

module.exports.default_configuration =
{
	ViewIdentifier: 'ChangeOrders',
	DefaultRenderable: 'ChangeOrdersWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: CO_CSS,
	Templates:
	[
		{
			Hash: 'ChangeOrders-Wrap',
			Template: /*html*/`<div class="co-wrap"><div id="CO-Body"></div></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ChangeOrdersWrap',
			TemplateHash: 'ChangeOrders-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
